import { useTranslation } from '@msdk/common'
import { Entity } from '@msdk/definitions'

import { getRoleLabel } from '../utils'

export const useRoleLabel = () => {
  const t = useTranslation()

  return (e: Entity) => getRoleLabel(e, t)
}
